const ROOT_API = process.env.VUE_APP_ROOT_API;
const GET_POINT_LIST = ROOT_API + 'get_lease_points.php';
const GET_ACT_GEOMETRIES = ROOT_API + '/act_lpo/get_act_geometries.php';
//const SET_ACT_TRACK = ROOT_API + '/act_lpo/set_act_track.php';

import fetchData from '@/lib/fetchData';
import processJSON from '@/lib/processJSON';
import { point } from '@turf/turf';

export default {
	state: {
		actPointList: [],
		actPointListLoading: false,
		actStrips: [],
		actTrack: null,
		lpoGeoms: []
	},

	mutations: {
		setActPointList(state, pointList) { state.actPointList = pointList; },
		setActPointListLoading(state, loading) { state.actPointListLoading = loading; },
		setActTrack(state, res) {state.actTrack = res;},
		setActGeometries(state, res) { 
			state.actStrips = res.strips;
			state.actTrack = res.track;
			state.lpoGeoms = res.lpo_geom;
		},
		clearActPointList(state) { state.actPointList = []; },
	},

	actions: {
		getActGeometries(context, payload) {
			const { rootState, commit } = context;
			if (!rootState.lpoData.currentLpo) {
				throw new Error('NO_CURRENT_LPO');
			}
			const lpo_id = rootState.lpoData.currentLpo.lpo_id
			const form = new FormData();
			form.append('lpo_id', lpo_id);

			return fetchData(GET_ACT_GEOMETRIES, form).then(res => {
				commit('setActGeometries', res);
			}).catch(err => {
				throw err;
			}).finally(() => {
				
			});
		},
		removeTrack(context) {
			const { state, rootState, commit } = context;
			commit('setActTrack', 'MULTILINESTRING EMPTY');
			if (!rootState.lpoData.currentLpo) {
				throw new Error('NO_CURRENT_LPO');
			}

			const lease_id = rootState.lpoData.currentLpo.lease_id;

			if (!lease_id) {
				throw new Error('CURRENT_LPO_HAS_NO_LEASE_ID');
			}

			const updateSection = [];
			const temp = {
				'tab_name': 'data_lpo_lease',
				'f_v': {
					'id': lease_id,
					'track': 'MULTILINESTRING EMPTY'
				}
			}
			updateSection.push(temp);
			const json_renum_obj = [
				{
					'u': updateSection
				}
			];
			const json_renum_str = JSON.stringify(json_renum_obj);
			return processJSON(json_renum_str).then(res => {
				//console.log(res)
				//state.actTrack = res
			})
		},
		addTrack(context, track) {
			const { state, rootState, commit } = context;
			commit('setActTrack', track);
			if (!rootState.lpoData.currentLpo) {
				throw new Error('NO_CURRENT_LPO');
			}

			const lease_id = rootState.lpoData.currentLpo.lease_id;

			if (!lease_id) {
				throw new Error('CURRENT_LPO_HAS_NO_LEASE_ID');
			}

			const updateSection = [];
			const temp = {
				'tab_name': 'data_lpo_lease',
				'f_v': {
					'id': lease_id,
					'track': track
				}
			}
			updateSection.push(temp);
			const json_renum_obj = [
				{
					'u': updateSection
				}
			];
			const json_renum_str = JSON.stringify(json_renum_obj);
			return processJSON(json_renum_str).then(res => {
				console.log(res)
				//state.actTrack = res
			})
		},
		getActPointList(context, payload) {
			const { rootState, commit } = context;

			if (!rootState.lpoData.currentLpo) {
				throw new Error('NO_CURRENT_LPO');
			}

			const lease_id = rootState.lpoData.currentLpo.lease_id;

			if (!lease_id) {
				throw new Error('CURRENT_LPO_HAS_NO_LEASE_ID');
			}

			const form = new FormData();
			form.append('lease_id', lease_id);

			commit('setActPointListLoading', true);

			return fetchData(GET_POINT_LIST, form).then(pointList => {
				commit('setActPointList', pointList);
			}).catch(err => {
				throw err;
			}).finally(() => {
				commit('setActPointListLoading', false);
			});

		},

		addPoint(context, point) {
			const { state, rootState, commit } = context;

			if (!rootState.lpoData.currentLpo) {
				throw new Error('NO_CURRENT_LPO');
			}

			const lease_id = rootState.lpoData.currentLpo.lease_id;

			if (!lease_id) {
				throw new Error('CURRENT_LPO_HAS_NO_LEASE_ID');
			}

			const updateSection = [];
			for (let i = +point.after; i < state.actPointList.length; ++i) {
				const updatedPoint = state.actPointList[i];

				const temp = {
					'tab_name': 'data_lpo_lease_points',
					'f_v': {
						'id': updatedPoint.id,
						'point_num': +updatedPoint.point_num + 1
					}
				};

				updateSection.push(temp);
			}

			const json_renum_obj = [
				{
					'u': updateSection
				}
			];

			const json_renum_str = JSON.stringify(json_renum_obj);
			// console.log(json_renum_str);
			// return;

			const json_obj = [
				{
					'i': {
						'tab': [
							{
								'tab_name': 'data_lpo_lease_points',
								'f_v': {
									'lease_id': lease_id,
									'point_num': Number(point.after) + 1,
									'lat': point.lat,
									'lon': point.lon
								}
							}
						]
					}
				}
			];
			const json_str = JSON.stringify(json_obj);
			// console.log(json_str);
			// return;

			return processJSON(json_renum_str).then(res => {
				return processJSON(json_str);
			});
		},

		removePoint(context, point) {
			const { state } = context;

			const updateSection = [];
			for (let i = +point.point_num; i < state.actPointList.length; ++i) {
				const updatedPoint = state.actPointList[i];

				const temp = {
					'tab_name': 'data_lpo_lease_points',
					'f_v': {
						'id': updatedPoint.id,
						'point_num': i
					}
				};

				updateSection.push(temp);
			}

			const json_renum_obj = [
				{
					'u': updateSection
				}
			];

			const json_renum_str = JSON.stringify(json_renum_obj);
			// console.log(json_renum_str);
			// return;

			const json_obj = [
				{
					'd': [
						{
							'tab_name': 'data_lpo_lease_points',
							'id': point.id
						}
					]
				}
			];

			const json_str = JSON.stringify(json_obj);
			// console.log(json_str);
			// return;

			return processJSON(json_str).then(res => {
				return processJSON(json_renum_str);
			})
		},
		removeAllPoints(context) {
			const { state } = context;

			const deleteSection = [];
			for (let i = 0; i < state.actPointList.length; i++) {
				const deletePoint = state.actPointList[i];

				const temp = {
					'tab_name': 'data_lpo_lease_points',
					'id': deletePoint.id
				};

				deleteSection.push(temp);
			}

			const json_obj = [
				{
					'd': deleteSection
				}
			];

			const json_str = JSON.stringify(json_obj);
			// console.log(json_str);
			// return;

			return processJSON(json_str).then(res => {
				
			})
		},

		addPointList(context, points) {
			const { rootState, dispatch } = context;

			const lease_id = rootState.lpoData.currentLpo.lease_id;

			// console.log(JSON.stringify(points, null, 2));
			const insertSection = [];
			for (let i = 0; i < points.length; ++i) {
				const point = points[i];

				const temp = {
					'tab_name': 'data_lpo_lease_points',
					'f_v': {
						'lease_id': lease_id,
						'point_num': i + 1,
						'lat': point.lat,
						'lon': point.lon,
					}
				};

				insertSection.push(temp);
			}

			const json_obj = [
				{
					'i': {
						'tab': insertSection
					}
				}
			];

			const json_str = JSON.stringify(json_obj);
			// console.log(json_str);
			// return;

			return dispatch('removeAllLeasePoints').then(res => {
				return processJSON(json_str);
			});
		},

		removeAllLeasePoints(context, points) {
			const { state } = context;

			const deleteSection = [];
			for (const point of state.actPointList) {
				const temp = {
					'tab_name': 'data_lpo_lease_points',
					'id': point.id
				};
				deleteSection.push(temp);
			}

			const json_obj = [
				{
					'd': deleteSection
				}
			];

			const json_str = JSON.stringify(json_obj);
			// console.log(json_str);
			// return;

			return processJSON(json_str);
		},

		saveLegend(context, legendList) {
			const { rootState } = context;

			const formattedList = legendList.length ?
				'{' + legendList.join(',') + '}' :
				null;

			if (!rootState.lpoData.currentLpo) {
				throw new Error('NO_CURRENT_LPO');
			}

			const lease_id = rootState.lpoData.currentLpo.lease_id;

			if (!lease_id) {
				throw new Error('CURRENT_LPO_HAS_NO_LEASE_ID');
			}

			const json_obj = [
				{
					'u': [
						{
							'tab_name': 'data_lpo_lease',
							'f_v': {
								'id': lease_id,
								'sketch_legend_ids': formattedList
							}
						}
					]
				}
			];

			const json_str = JSON.stringify(json_obj);
			// console.log(json_str);
			// return;

			return processJSON(json_str);
		},

	}
};